//import api from "../../services/api";

export default async function logFunc(...theArgs) {
	
	/* let first = true;
	if (theArgs[0] === 1){
		//console.log("llega tipo 1");
		for (const arg of theArgs) {
		if (!first) console.log("<-> ",arg);
		first = false;
	  }
	} */
	 
	return  true;
}